// extracted by mini-css-extract-plugin
export default {"fields":"EducationModal-module--fields--aH3oQ"};